<div class="form-group">
  <label for="buscar-por">{{ label }}:</label>
  <uni-select labelForId="buscar-por" [formControl]="searchTerm" [items]="searchTerms"></uni-select>
</div>
